import TimeUtil from '../backbone/utils/date/TimeUtil';
import i18next, { t } from 'i18next';
import { formatDuration } from 'utils/TimeFormatter';
import Personalizer from 'personalizer';
import AnalyticsUtil from '../backbone/utils/AnalyticsUtil';

const DEFAULT_ZONE_PERCENTS = [25, 55, 75, 90, 105, 120, 150, 200];
const MAX_ZONES = 7;
export const KEEP_EXISTING_VALUES = 'keepExistingValues';
export const SELECT_GENDER_OPTIONS = ['FEMALE', 'MALE'];
export const POWER_GUIDANCE_MAIN_ROUTE = 'power-guidance/create-strategy';
export const AERO_PROFILES_OPTIONS = ['RELAXED', 'STANDARD', 'OPTIMIZED'];
export const RESISTANCE_PROFILES_OPTIONS = ['MOUNTAIN', 'GRAVEL', 'ROAD'];
export const POWER_GUIDE_ANALYTICS = {
    CREATE_POWER_GUIDE_ACTION: 'Create Power Guide',
    GO_TO_POWER_GUIDE_ACTION: 'Go to Power Guide',
    VIEW_COURSE_ACTION: 'View Course',
    HELP_MODAL_OPENED_ACTION: 'Opened the Help Modal',
    UPDATE_USER_WEIGHT_ACTION: 'User weight Updated',
    UPDATE_USER_FTP_ACTION: 'User FTP Updated',
    POWER_GUIDE_SAVE_ACTION: 'Power Guide Saved',
    POWER_GUIDE_UPDATE_ACTION: 'Power Guide Updated',
    DELETE_POWER_GUIDE_ACTION: 'Delete Power Guide Clicked',
    DUPLICATE_POWER_GUIDE_ACTION: 'Duplicate Power Guide Clicked',
    SEND_POWER_GUIDE_TO_DEVICE_ACTION: 'Send Power Guide to Device Clicked',
    EDIT_COURSE_FROM_POWER_GUIDE_ACTION: 'Edit Course From Power Guide',
    CREATE_A_COURSE_FROM_POWER_GUIDE_ACTION: 'Create a Course From Power Guide',
    FAVORITE_A_COURSE_FROM_POWER_GUIDE_ACTION: 'Favorite a Course From Power Guide',
    SELECT_A_COURSE_FOR_POWER_GUIDE_SETUP_ACTION: 'Select a Course For Power Guide Setup',
    REPLACE_POWER_GUIDE_STRATEGY: 'Replace Power Guide strategy (remove and create new)',
    VIEW_POWER_GUIDE_STRATEGY: 'View Power Guide Strategy from Select a Course (PG Create)'
};

export const selectCourseUrl = 'power-guidance/select-course';

export const resistanceProfileOptionIndex = (selectedOption, isAeroProfile) => {
    if (selectedOption && typeof selectedOption === 'string') {
        selectedOption = selectedOption.toUpperCase();

        if (isAeroProfile) {
            return AERO_PROFILES_OPTIONS.indexOf(selectedOption);
        }

        return RESISTANCE_PROFILES_OPTIONS.indexOf(selectedOption);
    }
};

//todo change values once the UX team clarify this and set for KM also
export const SELECT_ABILITY_OPTIONS = [
    {
        value: 'UNTRAINED',
        label: 'ftp.untrained',
        max: 23000
    },
    {
        value: 'FAIR',
        label: 'ftp.fair',
        min: 23000,
        max: 28000
    },
    {
        value: 'GOOD',
        label: 'ftp.good',
        min: 29000,
        max: 34000
    },
    {
        value: 'EXCELLENT',
        label: 'ftp.excellent',
        min: 35000,
        max: 37000
    },
    {
        value: 'SUPERIOR',
        label: 'ftp.superior',
        min: 37000
    }
];

export const BIKE_GEAR_WEIGHT_GRAMS = {
    roadBike: { min: 10000, max: 12000, label: 'road_bike_approx_weight' },
    gravelBike: { min: 13000, max: 15000, label: 'gravel_bike_approx_weight' },
    mountainBike: { min: 16000, max: 17000, label: 'mountain_bike_approx_weight' },
    loadedTouringBike: { min: 20000, max: 22000, label: 'loaded_touring_bike_approx_weight' },
    custom: { min: null, max: null }
};
export const MAX_CUSTOM_GEAR_WEIGHT_GRAMS = 453000;
export const MIN_CUSTOM_GEAR_WEIGHT_GRAMS = 1000;
export const MAX_USER_WEIGHT_GRAMS = 453000;
export const MIN_USER_WEIGHT_GRAMS = 1000;
export const MAX_COURSE_DISTANCE = 402500;
export const MIN_COURSE_DISTANCE = 15000;
export const MAX_COURSE_DISTANCE_KM = 400;
export const MIN_COURSE_DISTANCE_KM = 15;
export const MAX_COURSE_DISTANCE_MILES = 250;
export const MIN_COURSE_DISTANCE_MILES = 10;

export const updatePowerZonesValues = (powerZones) => {
    // user always has 7 zones
    //set power zone sport if not available default to cycling since it is power guide for cycling
    let updatedPowerZones = {
        sport: powerZones && powerZones.sport ? powerZones.sport : 'CYCLING',
        ...powerZones
    };
    for (let i = 1; i <= MAX_ZONES; i++) {
        let percent = DEFAULT_ZONE_PERCENTS[i];
        let watts = percentToPowerWatts(updatedPowerZones.functionalThresholdPower, percent);
        if (i < MAX_ZONES + 1) {
            updatedPowerZones['zone' + i + 'Floor'] = watts;
        }
    }
    return updatedPowerZones;
};

export const percentToPowerWatts = (functionalThresholdPower, percent) => {
    return Math.round((percent * functionalThresholdPower) / 100);
};

export const getDuration = (givenTime) => {
    let time = TimeUtil.secondsToTime(givenTime);
    let endCondition = '';
    if (time.h > 0) {
        let hourLabel = time.h < 2 ? t('units:duration_hour_lowercase') : t('units:duration_hours_lowercase');
        endCondition += time.h + ' ' + hourLabel + ' ';
    }
    if (time.m > 0) {
        let minuteLabel = time.m < 2 ? t('units:duration_minute_lowercase') : t('units:duration_minutes_lowercase');
        endCondition += time.m + ' ' + minuteLabel + ' ';
    }
    if (time.s > 0) {
        let secondLabel = time.s < 2 ? t('units:duration_second_lowercase') : t('units:duration_seconds_lowercase');
        endCondition += time.s + ' ' + secondLabel;
    }

    return endCondition;
};

export const getDurationShortFormat = (givenTime) => {
    let time = TimeUtil.secondsToTime(givenTime);
    let endCondition = '';
    if (time.h > 0) {
        let hourLabel = t('units:duration_hour_short');
        endCondition += time.h + ' ' + hourLabel + ' ';
    }
    if (time.m > 0) {
        let minuteLabel = t('units:duration_minute_short');
        endCondition += time.m + ' ' + minuteLabel + ' ';
    }
    if (time.s > 0) {
        let secondLabel = t('units:duration_second_short');
        endCondition += time.s + ' ' + secondLabel;
    }

    return endCondition;
};

export const getDurationForSplit = (givenTime) => {
    //the display format in unknown yet - might be a range but the condtion is unclear atm

    return formatDuration(givenTime, undefined, undefined, false);
};

export const getShortDurationShortLabel = (givenTime) => {
    let time = TimeUtil.secondsToTime(givenTime);
    let finalDurations = '';

    if (time.h > 0) {
        finalDurations += time.h + t('units:duration_hour_short');
    } else if (time.m > 0) {
        finalDurations += time.m + t('units:duration_minute_short');
    } else if (time.s > 0) {
        finalDurations += time.s + t('units:duration_second_short');
    }

    return finalDurations;
};

export const getAproxDurationWithLabel = (estimatedDurationLow, estimatedDurationHigh) => {
    const fortyFiveMinutes = 0.75;
    const oneAndAHalfHours = 1.5;
    const fourHours = 4;
    const sixHours = 6;
    const tenHours = 10;
    const fortyEight = 48;

    // --------------------------------------------------
    //  Min   Max   Precision   Range   Text
    // --------------------------------------------------
    //  0     0.75    1              0.5     Less than 1 hour
    //  0.75  1.5      1              0.5     About 1 hour
    //  1.5      4        0.25          1       From x-y hours
    //  4        6        0.5            1.5     From x-y hours
    //  6        10      1              2       From x-y hours
    //  10      48      1              3       From x-y hours

    if (
        estimatedDurationLow === null ||
        (estimatedDurationHigh === null && isNaN(estimatedDurationLow)) ||
        isNaN(estimatedDurationHigh)
    ) {
        return 0;
    }

    if (estimatedDurationLow === 0 || estimatedDurationHigh <= fortyFiveMinutes) {
        return t('power_guidance:less_than_one_hour');
    } else if (estimatedDurationLow <= fortyFiveMinutes || estimatedDurationHigh <= oneAndAHalfHours) {
        return t('power_guidance:about_one_hour');
    }

    //estimatedDuration is received as hours
    let minValSecondsToTime = TimeUtil.secondsToTime(estimatedDurationLow * 3600);
    let maxValSecondsToTime = TimeUtil.secondsToTime(estimatedDurationHigh * 3600);
    let returnFromString = `${minValSecondsToTime.h + t('units:duration_hour_short')}${
        minValSecondsToTime.m ? minValSecondsToTime.m + t('units:duration_minute_short') : ''
    }`;
    let returnToString = `${maxValSecondsToTime.h + t('units:duration_hour_short')}${
        maxValSecondsToTime.m ? maxValSecondsToTime.m + t('units:duration_minute_short') : ''
    }`;

    if (estimatedDurationLow !== estimatedDurationHigh) {
        //    if the two values are different then we can display the given estimate
        return `${returnFromString} - ${returnToString}`;
    }

    // fallbacks for if the low and high values are the same
    if (estimatedDurationLow <= oneAndAHalfHours || estimatedDurationHigh <= fourHours) {
        minValSecondsToTime = TimeUtil.secondsToTime(oneAndAHalfHours * 3600);
        maxValSecondsToTime = TimeUtil.secondsToTime(fourHours * 3600);
    } else if (estimatedDurationLow <= fourHours || estimatedDurationHigh <= sixHours) {
        minValSecondsToTime = TimeUtil.secondsToTime(fourHours * 3600);
        maxValSecondsToTime = TimeUtil.secondsToTime(sixHours * 3600);
    } else if (estimatedDurationLow <= sixHours || estimatedDurationHigh <= tenHours) {
        minValSecondsToTime = TimeUtil.secondsToTime(sixHours * 3600);
        maxValSecondsToTime = TimeUtil.secondsToTime(tenHours * 3600);
    } else if (estimatedDurationLow <= tenHours || estimatedDurationHigh <= fortyEight) {
        minValSecondsToTime = TimeUtil.secondsToTime(tenHours * 3600);
        maxValSecondsToTime = TimeUtil.secondsToTime(fortyEight * 3600);
    }
    returnFromString = `${minValSecondsToTime.h + t('units:duration_hour_short')}${
        minValSecondsToTime.m ? minValSecondsToTime.m + t('units:duration_minute_short') : ''
    }`;
    returnToString = `${maxValSecondsToTime.h + t('units:duration_hour_short')}${
        maxValSecondsToTime.m ? maxValSecondsToTime.m + t('units:duration_minute_short') : ''
    }`;

    return `${returnFromString} - ${returnToString}`;
};

export const setSummaryDataFromAlgorithm = (algorithmData, courseId, courseDistance, userFtp, userProfilePk) => {
    let algorithmPlanPointsData = algorithmData.planPoints;
    let returnObj = {
        //estimatedDuration is total duration
        estimatedDuration: 0,
        splitCount: algorithmPlanPointsData.length,
        userProfilePk,
        coursePk: courseId,
        distance: courseDistance,
        ftpUsagePercent: 0,
        meanPowerUsage: 0,
        maxPowerUsage: 0,
        estimatedDurationHigh: algorithmData.summary.summaryHoursUpper,
        estimatedDurationLow: algorithmData.summary.summaryHoursLower
    };

    if (!isNaN(algorithmData.summary.aeroCoefficient)) {
        returnObj.aeroCoefficient = algorithmData.summary.aeroCoefficient;
    }
    if (!isNaN(algorithmData.summary.rollingResistanceCoefficient)) {
        returnObj.rollingResistanceCoefficient = algorithmData.summary.rollingResistanceCoefficient;
    }

    //meanPowerUsage is sum of (segmentDuration * powerTarget) / totalDuration
    let segmentDurationPowerTarget = 0;

    algorithmPlanPointsData.forEach((item) => {
        if (item.estimatedSeconds) {
            returnObj.estimatedDuration += item.estimatedSeconds;
        }
        if (item.powerTargetWatts > returnObj.maxPowerUsage) {
            returnObj.maxPowerUsage = item.powerTargetWatts;
        }
        segmentDurationPowerTarget += item.estimatedSeconds * item.powerTargetWatts;
    });

    segmentDurationPowerTarget = segmentDurationPowerTarget / returnObj.estimatedDuration;

    returnObj.meanPowerUsage = Math.round(segmentDurationPowerTarget);

    if (!isNaN(userFtp) && userFtp !== null) {
        //calculate ftp of meanPower
        returnObj.ftpUsagePercent = Math.round((returnObj.meanPowerUsage * 100) / userFtp);
    }

    return returnObj;
};

function radians_to_degrees(radians) {
    // Multiply radians by 180 divided by pi to convert to degrees.
    return radians * (180 / Math.PI);
}

export const setSplitsDataFromAlgorithm = (algorithmData, courseGeoPoints, powerGuidanceSummaryData) => {
    let returnObject = {
        splitArr: [],
        chartDataArr: []
    };
    let powerGuidancePk = powerGuidanceSummaryData && powerGuidanceSummaryData.powerGuidancePk;
    let cumulativeDistance = 0;
    let currentSplitCoursePointStartIndex = 0;

    algorithmData.forEach((item, index) => {
        let splitData = {};
        let currentSplitCoursePointEndIndex = item.coursePointIndex;
        let algorithmSplitStart = courseGeoPoints[currentSplitCoursePointStartIndex];
        let algorithmSplitEnd = courseGeoPoints[currentSplitCoursePointEndIndex];

        //first item received from algorithm contains values 0 - it is the start
        if (algorithmSplitStart && algorithmSplitEnd) {
            if (powerGuidancePk) {
                //if is in edit mode then we have the powerGuidancePk and we need to set it
                splitData.powerGuidancePk = powerGuidancePk;
            }

            let elevChange = item.ascent;
            let dist = algorithmSplitEnd.distance - algorithmSplitStart.distance;
            let meanGradeData = item.slope * 100;

            //values taken from algorithm item
            splitData.powerTarget = item.powerTargetWatts ? item.powerTargetWatts : 1;
            splitData.estimatedDuration = item.estimatedSeconds;
            splitData.heading = item.heading;

            //values taken from calculations based on course point info
            splitData.distance = dist;
            splitData.coursePointIndex = currentSplitCoursePointStartIndex;
            cumulativeDistance = algorithmSplitEnd.distance;
            splitData.cumulativeDistance = cumulativeDistance;
            splitData.meanGrade = setTwoDecimals(meanGradeData);
            splitData.startLongitude = algorithmSplitStart.longitude;
            splitData.startLatitude = algorithmSplitStart.latitude;
            splitData.startElevation = algorithmSplitStart.elevation;
            splitData.endLongitude = algorithmSplitEnd.longitude;
            splitData.endLatitude = algorithmSplitEnd.latitude;
            splitData.endElevation = algorithmSplitEnd.elevation;
            splitData.elevationChange = elevChange;

            returnObject.splitArr.push(splitData);

            let chartData = setChartSplitData(
                courseGeoPoints,
                splitData,
                currentSplitCoursePointStartIndex,
                currentSplitCoursePointEndIndex,
                powerGuidanceSummaryData.userFTP
            );

            returnObject.chartDataArr = [...returnObject.chartDataArr, ...chartData];
        }

        currentSplitCoursePointStartIndex = item.coursePointIndex;
    });

    return returnObject;
};

export const getChartDataBasedOnSplits = (courseGeoPoints, splitsData, userFTP) => {
    let chartDataArr = [];

    splitsData.forEach((item, index) => {
        let currentCoursePointIndex = item.coursePointIndex;
        let currentCoursePointEndIndex = splitsData[index + 1]
            ? splitsData[index + 1].coursePointIndex
            : courseGeoPoints.length - 1;

        let chartData = setChartSplitData(
            courseGeoPoints,
            item,
            currentCoursePointIndex,
            currentCoursePointEndIndex,
            userFTP
        );
        chartDataArr = [...chartDataArr, ...chartData];
    });

    return chartDataArr;
};

const setChartSplitData = (points, splitData, currentCoursePointIndex, currentCoursePointEndIndex, ftp) => {
    let returnArr = [];
    let splitEndIndex = currentCoursePointEndIndex !== points.length - 1 ? currentCoursePointEndIndex : points.length;
    let splitGeoPoints = points.slice(currentCoursePointIndex, splitEndIndex);

    splitGeoPoints.forEach((item) => {
        let pointData = {
            splitNumber: currentCoursePointIndex,
            elevation: item.elevation,
            distance: item.distance,
            meanGrade: splitData.meanGrade,
            powerTargetWatts: splitData.powerTarget,
            userFtp: ftp
        };
        returnArr.push(pointData);
    });

    return returnArr;
};

export const powerGuidanceIntervalsAreEqual = (intervals1, intervals2) => {
    if (intervals1.length !== intervals2.length) {
        return false;
    }

    for (let i = 0; i < intervals1.length; i++) {
        const interval1 = intervals1[i];
        const interval2 = intervals2[i];
        if (!intervalsAreEqual(interval1, interval2)) {
            return false;
        }
    }

    return true;
};

const intervalsAreEqual = (interval1, interval2) => {
    return (
        interval1.powerTarget === interval2.powerTarget && interval1.estimatedDuration === interval2.estimatedDuration
    );
};

export const getCourseDistanceRestrictionsText = () => {
    let minDistance, maxDistance, distanceUnit;

    if (Personalizer.measurementSystem === Personalizer.MeasurementSystems.METRIC) {
        distanceUnit = t('units:label_distance_unit_metric');
        minDistance = MIN_COURSE_DISTANCE_KM;
        maxDistance = MAX_COURSE_DISTANCE_KM;
    } else {
        distanceUnit = t('units:label_distance_unit_statute');
        minDistance = MIN_COURSE_DISTANCE_MILES;
        maxDistance = MAX_COURSE_DISTANCE_MILES;
    }

    return t('power_guidance:create_strategy_warning', {
        0: minDistance,
        1: maxDistance,
        2: distanceUnit.toLowerCase()
    });
};

export const setTwoDecimals = (value) => {
    return Math.round(value * 100) / 100;
};

export const pushPowerGuideEventToAnalytics = (action, label) => {
    AnalyticsUtil.push({
        event: 'track_event',
        category: 'Power Guide Events',
        action: action,
        label: label
    });
};
